<template>
  <section id="report" class="slideDown">
    <div class="container">
      <div class="content">
        <div class="back" @click="back()">
          {{ $t('partner.report.return') }}
        </div>

        <h3 class="title">
          <span v-if="!isEdit">{{ $t('partner.report.title') }}</span>
          <span v-else>
            <b>{{ humanizeDate(reportDate) }}</b></span
          >
        </h3>

        <!-- ADD TEMPLATE -->
        <template v-if="!isEdit">
          <v-form ref="form_report">
            <v-container grid-list-xl>
              <v-layout row>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('partner.report.select_file')"
                    @click="onPickFile"
                    v-model="fileName"
                    prepend-icon="attach_file"
                  ></v-text-field>
                  <!-- Hidden -->
                  <input
                    type="file"
                    style="display: none"
                    ref="fileInput"
                    accept=".zip,.rar"
                    @change="onFilePicked"
                  />
                </v-flex>

                <v-flex xs6>
                  <v-select
                    v-model="report.date"
                    :items="avaiableDates"
                    :label="$t('partner.report.date')"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <div class="buttons">
            <v-btn large color="success" @click="save()">{{ $t('general.save') }}</v-btn>
            <v-btn large color="cancel" @click="back()">{{ $t('general.back') }}</v-btn>
          </div>
        </template>

        <!-- EDIT TEMPLATE-->
        <template v-else>
          <div class="details">
            <!-- <div class="subtitle">Información básica</div> -->
          </div>
          <div class="meta">
            <div class="filters">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar informe"
                single-line
                hide-details
              ></v-text-field>
            </div>
            <div class="buttons">
              <v-btn outline @click="showPDFform = !showPDFform"
                ><template v-if="!showPDFform"
                  >{{ $t('partner.report.add_pdf') }}</template
                ><template v-else
                  >{{ $t('partner.report.cancel_pdf') }}</template
                ></v-btn
              >
              <v-btn outline @click="removeAll()" color="success"
                >{{ $t('partner.report.remove_all') }}</v-btn
              >
            </div>
          </div>
          <div class="dynamic" :class="{ visible: showPDFform }">
            <v-form ref="form_pdf">
              <div class="left">
                <v-text-field
                  :label="$t('partner.report.select_pdf')"
                  @click="onPickFile"
                  v-model="fileName"
                  prepend-icon="attach_file"
                  hide-details
                  color="black"
                  dense
                ></v-text-field>
                <!-- Hidden -->
                <input
                  type="file"
                  style="display: none"
                  ref="fileInput"
                  accept=".pdf"
                  @change="onFilePicked"
                />
              </div>
              <div class="right">
                <v-btn outline color="cancel" @click="uploadPDF()"
                  >{{ $t('partner.report.add_pdf') }}</v-btn
                >
              </div>
            </v-form>
          </div>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="Object.values(report)"
            no-data-text="$t('partner.report.empty')"  
            :no-results-text="message_not_found"
            :rows-per-page-items="rows_per_page"
            :pagination.sync="pagination"
            attach
            :rows-per-page-text="message_rows_per_page"
          >
            <template v-slot:items="props">
              <tr>
                <td style="margin-left: 20px;">
                  {{ props.item.report_filename }}
                </td>
                <td style="text-align:left">
                  {{ props.item.created_date }}
                </td>

                <td class="icons">
                  <v-icon @click="preview(props.item.report_filename)"
                    >visibility</v-icon
                  >
                  <v-icon @click="remove(props.item)">delete</v-icon>
                  <!-- <v-icon class="up" @click="up(props.item)">arrow_upward</v-icon
            ><v-icon class="down" @click="down(props.item)"
              >arrow_downward</v-icon
            > -->
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import i18n from "@/i18n";
export default {
  props: {
    reportsResume: Array
  },
  data() {
    return {
      headers: [
        {
          text: i18n.t('partner.report.name'),
          value: "report_filename",
          sortable: true,
          width: "50%"
        },
        {
          text: i18n.t('partner.report.last_update'),
          value: "created_date",
          sortable: true,
          width: "calc(50% - 100px)"
        },
        {
          text: "",
          value: "",
          sortable: false,
          width: "100px"
        }
      ],
      id: -1,
      message_not_found: i18n.t('partner.report.empty'),
      message_rows_per_page: i18n.t('partner.report.rows_per_page'),
      rows_per_page: [10, 25, 50, { text: i18n.t('general.all'), value: -1 }],
      pagination: {
        rowsPerPage: 10,
        sortBy: "date",
        descending: true
      },
      search: "",
      fileName: "",
      file: false,
      showPDFform: false
    };
  },
  created() {
    // console.log(this.report);
    // var date = this.report.date != -1 ? this.report.date : "add";
    // console.log(date);
  },
  computed: {
    report() {
      return { ...this.$store.getters["reports/getCurrentReport"] };
    },

    isEdit() {
      return this.report.date != -1;
    },

    reportDate() {
      return this.$route.params.date;
    },

    avaiableDates() {
      var result = [];
      // HOW MANY MONTHS ON THE SELECT
      var months = 6;

      // GET DISABLED DATES
      let disabledDates = this.reportsResume.map(a => a.date);

      for (var i = 0; i < months; i++) {
        var date = moment().subtract(i, "months");
        var oDate = {
          text: date.format("MMMM - YYYY"),
          value: date.format("MM/YYYY")
        };

        if (disabledDates.includes(date.format("MM/YYYY")))
          oDate.disabled = true;
        result.push(oDate);
      }
      return result;
    }
  },
  methods: {
    preview(file) {
      window.open(
        process.env.VUE_APP_S3_URL +
          "reports/" +
          this.reportDate.replace("/", "-") +
          "/" +
          file
      );
    },

    humanizeDate(date) {
      return date
        ? moment(date.replace("/", "/01/")).format("MMMM - YYYY")
        : "";
    },

    back() {
      this.$store.commit("reports/setCurrentReport", false);
      this.$router.push({ name: "reports" });
    },

    save() {
      var self = this;

      this.report.filename = this.fileName;

      var aData = {};
      aData.file = this.file;
      aData.report = this.report;

      this.$overlay.loading();
      this.$store
        .dispatch("reports/uploadReport", aData)
        .then(function(response) {
          self.$overlay.hide();
          self.back();
        });
    },

    uploadPDF() {
      var self = this;
      var pdf = {};

      pdf.filename = this.fileName;
      pdf.date = this.reportDate;

      var aData = {};
      aData.file = this.file;
      aData.pdf = pdf;

      this.$overlay.loading();

      this.$store.dispatch("reports/uploadPdf", aData).then(function(response) {
        self.clearPDFSelected();
        self.$emit("updateReports");
        self.$overlay.hide();
      });
    },

    remove(report) {
      var self = this;

      this.$popup.confirm(
        i18n.t('partner.report.popup.title'),
        i18n.t('partner.report.popup.description', { name: `<b>${report.report_filename}</b>` }),
        i18n.t('general.delete'),
        i18n.t('general.cancel'),
        function() {
          var oReport = {
            id: report.id,
            report_filename: report.report_filename,
            report_date: report.report_date
          };

          self.$overlay.loading();

          self.$store
            .dispatch("reports/deleteReport", oReport)
            .then(function(response) {
              self.$emit("updateReports");
              self.$overlay.hide();
            });
        }
      );
    },

    removeAll() {
      var self = this;

      this.$popup.confirm(
        i18n.t('partner.report.popup.title_all', { name: this.humanizeDate(this.reportDate) }),
        i18n.t('partner.report.popup.description_all', { name: `<b>${this.humanizeDate(this.reportDate)}</b>` }),
        i18n.t('general.delete'),
        i18n.t('general.cancel'),
        function() {
          self.$overlay.loading();
          self.$store
            .dispatch(
              "reports/deleteAllReport",
              self.reportDate.replace("/", "-")
            )
            .then(function(response) {
              self.$overlay.hide();
              self.back();
            });
        }
      );
    },

    onPickFile() {
      this.$refs.fileInput.click();
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.fileName = files[0].name;
        this.file = files[0];
      } else {
        this.fileName = "";
      }
    },

    clearPDFSelected() {
      this.file = false;
      this.fileName = "";
      this.showPDFform = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.back {
  background: url(/img/left-arrow.svg) no-repeat left center;
  text-align: left;
  margin-bottom: 40px;
  padding-left: 25px;
  cursor: pointer;
  width: fit-content;
}
.container {
  width: 100%;
  overflow: hidden;
  padding-bottom: 0;
  padding-top: 0;

  .content {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
    text-align: left;
    // padding: 0 25px;

    .title {
      margin: 10px 0;
      font-size: 20pt;
      font-family: Speedee-Bold !important;
    }
    .subtitle {
      margin-bottom: 25px;
      color: #888;
    }
    .buttons {
      // margin: 35px 0;
      text-align: center;
    }

    .meta {
      display: block;
      overflow: auto;

      .filters {
        float: left;
        width: 50%;
        text-align: right;
        padding: 0 10px;

        .filter {
          display: inline-block;
          margin-right: 20px !important;
        }

        .search {
          display: block;
          overflow: hidden;
          margin-top: 5px;
          -webkit-transition: all 1s;
          transition: all 1s;

          .input {
            border: none;
            border-bottom: 2px solid #ccc;
            padding: 5px;
            outline: none;
            background: url("/img/magnify.svg") no-repeat right 5px center;
            background-size: 20px;
            width: 100%;
            float: left;
          }
          .icon {
            display: none;
            cursor: pointer;
            width: 30px;
            height: 30px;
            background: url("/img/go.svg") no-repeat center var(--main_color);
            background-size: 20px;
            border-radius: 3px;
          }
          &.active {
            .input {
              width: calc(100% - 40px);
              background: transparent;
            }
            .icon {
              display: inline-block;
            }
          }
        }
      }

      .buttons {
        // margin: 35px 0;
        text-align: center;
        float: right;
        padding: 10px 0;
        width: 50%;

        .v-btn {
          width: 47%;
          overflow: hidden;
          display: inline-block;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;
        }
      }
    }

    .dynamic {
      display: block;
      background-color: #ddd;
      overflow: hidden;
      max-height: 0px;
      transition: all 500ms;
      border-radius: 2px;

      .left {
        padding: 10px;

        width: 50%;
        float: left;
      }
      .right {
        padding: 15px 10px;
        max-width: 50%;
        float: right;
      }

      &.visible {
        // padding: 10px;
        margin-bottom: 15px;
        max-height: 100px;
        height: auto;
        height: fit-content;
      }
    }

    // TABLE STYLES
    .icon {
      .v-icon {
        display: inline;
      }
    }
  }
}
</style>
